import { useLayoutEffect, useRef } from 'react';

const useLockBodyScroll = () => {
  const scrollOffset = useRef(0);

  useLayoutEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    scrollOffset.current = window.pageYOffset;
    // const scrollBarCompensation = window.innerWidth - document.body.offsetWidth;

    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.top = `-${window.pageYOffset}px`;
    document.body.style.overflowY = 'scroll';
    document.body.style.position = 'fixed';
    // document.body.style.paddingRight = `${scrollBarCompensation}px`;
    document.body.style.width = '100%';

    return () => {
      document.body.style.overflowY = '';
      document.body.style.paddingRight = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollOffset.current);
      document.documentElement.style.scrollBehavior = 'smooth';
    };
  }, []);
};

export default useLockBodyScroll;
